import { makeStyles } from "@material-ui/core/styles";
import {
  DASHBOARD_CARD_SMALL,
  BREAKPOINT_MD,
  BREAKPOINT_SM,
  DASHBOARD_CARD_MEDIUM,
  DASHBOARD_CARD_EXTRA,
  DASHBOARD_CARD_LARGE,
  DASHBOARD_CARD_EXTRA_LARGE,
} from "../../../../util/Constants";
import { isNil } from "lodash";

export const commonIcon = {
  width: "auto",
  height: "auto",
  padding: 1,
};

function getCommonRootCard(theme, props) {
  return {
    borderLeft: props?.hidden
      ? `15px solid grey`
      : props?.indColor
      ? `15px solid ${props?.indColor}`
      : `15px solid ${theme.palette.content.mainColor}`,
    cursor: "pointer",
    backgroundColor: `${theme.palette.content.cardsBackground}BB`,
    boxSizing: `border-box`,
    "&:hover": {
      backgroundColor: `${theme.palette.content.cardsBackground}FF`,
      border: props?.hidden
        ? `1px solid grey`
        : props?.indColor
        ? `1px solid ${props?.indColor}`
        : `1px solid ${theme.palette.content.mainColor}`,
      borderLeft: props?.hidden
        ? `15px solid grey`
        : props?.indColor
        ? `15px solid ${props?.indColor}`
        : `15px solid ${theme.palette.content.mainColor}`,
    },
    width: "82vw",
  };
}

function getCircleSize(cardSize) {
  if (isNil(cardSize) || cardSize === DASHBOARD_CARD_SMALL) {
    return 40;
  }

  if (cardSize === DASHBOARD_CARD_MEDIUM) {
    return 55;
  }

  if (cardSize === DASHBOARD_CARD_LARGE) {
    return 65;
  }

  if (cardSize === DASHBOARD_CARD_EXTRA) {
    return 120;
  }

  return 240;
}

export const useStyles = makeStyles((theme) => ({
  megaLargeRootCard: (props) => ({
    ...getCommonRootCard(theme, props),
    [theme.breakpoints.up(BREAKPOINT_MD)]: {
      width: 600,
    },
    [theme.breakpoints.between(BREAKPOINT_SM, BREAKPOINT_MD)]: {
      width: "90vw",
    },
    height: 450,
  }),
  extraLargeRootCard: (props) => ({
    ...getCommonRootCard(theme, props),
    [theme.breakpoints.up(BREAKPOINT_MD)]: {
      width: 450,
    },
    [theme.breakpoints.between(BREAKPOINT_SM, BREAKPOINT_MD)]: {
      width: "90vw",
    },
    height: 300,
  }),
  extraRootCard: (props) => ({
    ...getCommonRootCard(theme, props),
    [theme.breakpoints.up(BREAKPOINT_MD)]: {
      width: 300,
    },
    [theme.breakpoints.between(BREAKPOINT_SM, BREAKPOINT_MD)]: {
      width: "90vw",
    },
    height: 220,
  }),
  largeRootCard: (props) => ({
    ...getCommonRootCard(theme, props),
    [theme.breakpoints.up(BREAKPOINT_MD)]: {
      width: 300,
    },
    [theme.breakpoints.between(BREAKPOINT_SM, BREAKPOINT_MD)]: {
      width: "90vw",
    },
    height: 110,
  }),
  mediumRootCard: (props) => ({
    ...getCommonRootCard(theme, props),
    [theme.breakpoints.up(BREAKPOINT_MD)]: {
      width: 250,
    },
    [theme.breakpoints.between(BREAKPOINT_SM, BREAKPOINT_MD)]: {
      width: "90vw",
    },
    height: 90,
  }),
  smallRootCard: (props) => ({
    ...getCommonRootCard(theme, props),
    [theme.breakpoints.up(BREAKPOINT_MD)]: {
      width: 200,
    },
    [theme.breakpoints.between(BREAKPOINT_SM, BREAKPOINT_MD)]: {
      width: "90vw",
    },
    height: 70,
  }),
  commonCenteredContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  cardContent: {
    width: "100%",
    height: "100%",
    position: "relative",
    padding: "3px 5px !important",
  },
  cardContentDiv: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  cardIndContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  cardContentInd: {
    display: "flex",
    flexDirection: ({ cardSize }) =>
      DASHBOARD_CARD_EXTRA === cardSize ||
      DASHBOARD_CARD_EXTRA_LARGE === cardSize
        ? "column-reverse"
        : "row",
    alignItems: "center",
    justifyContent: ({ cardSize }) =>
      DASHBOARD_CARD_EXTRA === cardSize ||
      DASHBOARD_CARD_EXTRA_LARGE === cardSize
        ? "center"
        : "flex-start",
    height: "100%",
    gap: "10px",
  },
  indCircleLabelCont: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: 80,
  },
  indCircle: {
    marginTop: 5,
    borderRadius: "100%",
    minWidth: ({ cardSize }) => getCircleSize(cardSize),
    minHeight: ({ cardSize }) => getCircleSize(cardSize),
    border: ({ indColor }) =>
      indColor ? `5px solid ${indColor}` : "5px solid white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  indRefreshBtn: {
    position: "absolute",
    bottom: 5,
    right: 5,
    padding: 3,
    display: "none",
  },
  kpiNameTypo: {
    maxHeight: ({ cardSize }) =>
      DASHBOARD_CARD_EXTRA !== cardSize &&
      DASHBOARD_CARD_EXTRA_LARGE !== cardSize
        ? "-webkit-fill-available"
        : "auto",
    overflowY: ({ cardSize }) =>
      DASHBOARD_CARD_EXTRA !== cardSize &&
      DASHBOARD_CARD_EXTRA_LARGE !== cardSize &&
      "auto",
    width: ({ cardSize }) =>
      DASHBOARD_CARD_EXTRA === cardSize ||
      DASHBOARD_CARD_EXTRA_LARGE === cardSize
        ? "90%"
        : "auto",
    textAlign: "center",
  },
  typoValue: {
    fontWeight: "bolder",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: ({ cardSize }) => getCircleSize(cardSize) - 10,
  },
  labelValue: {
    maxWidth: ({ cardSize }) => getCircleSize(cardSize),
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  fetchingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  chartContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  cardEditBtn: {
    position: "absolute",
    top: 5,
    right: 5,
    padding: 5,
  },
  selectedOption: {
    fontWeight: "bold",
  },
}));
